import { createContext } from "react";

export const ContextualHelpContext = createContext(null);